module.exports = __webpack_public_path__ + "img/sparkles-glitter.18ce4d8.svg";